import React from 'react';
import { getWarningStyle, buildDeadlineSummary } from '../../utils/refundTimeline';

const RefundDeadlineBadge = ({ timeline, large = false }) => {
  const summary = buildDeadlineSummary(timeline);
  if (!summary) return null;

  const style = getWarningStyle(summary.level, timeline?.policy);
  const fontSize = large ? '15px' : '12px';
  const padding = large ? '8px 14px' : '4px 10px';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: large ? '6px' : '4px' }}>
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
          padding,
          borderRadius: '999px',
          fontSize,
          fontWeight: 700,
          background: style.bg,
          color: style.color,
          border: `1px solid ${style.border}`,
          width: 'fit-content',
        }}
      >
        {style.label} · {summary.text}
      </span>
      {summary.penalty > 0 && (
        <span style={{ fontSize: large ? '14px' : '11px', color: '#b91c1c', fontWeight: 600 }}>
          Penalty: ₹{summary.penalty} · Net payout: ₹{summary.netPayout ?? '—'}
        </span>
      )}
    </div>
  );
};

export default RefundDeadlineBadge;
